/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_ItalicInputs */

const en_wc_tut_keys_italic = /** @type {(inputs: Wc_Tut_Keys_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italic`)
};

/**
* | output |
* | --- |
* | "Italic" |
*
* @param {Wc_Tut_Keys_ItalicInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_italic = /** @type {((inputs?: Wc_Tut_Keys_ItalicInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_ItalicInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_italic(inputs)
});
export { wc_tut_keys_italic as "wc.tut.keys.italic" }